import React from "react";
import NodePorts from "./NodePorts";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography } from "@material-ui/core";
import { Code } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  nodeContainer: {
    minWidth: 200,
    maxWidth: 280,
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    background: "linear-gradient(135deg, #00BCD4 0%, #0097A7 100%)",
    boxShadow: "0 4px 12px rgba(0, 188, 212, 0.4)",
    border: "2px solid #00BCD4",
    color: "white",
    position: "relative",
    transition: "all 0.2s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 6px 16px rgba(0, 188, 212, 0.5)",
    },
  },
  nodeHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  nodeIcon: {
    fontSize: 20,
  },
  nodeLabel: {
    fontWeight: 600,
    fontSize: 14,
    color: "white",
  },
  nodeContent: {
    fontSize: 12,
    opacity: 0.95,
    marginTop: theme.spacing(0.5),
    padding: theme.spacing(1),
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    borderRadius: 8,
    maxHeight: 100,
    overflow: "hidden",
    textOverflow: "ellipsis",
    wordBreak: "break-word",
  },
  nodeMeta: {
    fontSize: 11,
    opacity: 0.9,
    marginTop: theme.spacing(0.5),
  },
  handle: {
    width: 12,
    height: 12,
    background: "white",
    border: "2px solid #00BCD4",
    borderRadius: "50%",
  },
}));

const OpenAINode = ({ data, selected }) => {
  const classes = useStyles();
  const agentName = data?.promptName || data?.label || "Agente IA";
  const promptId = data?.promptId;

  return (
    <Box
      className={classes.nodeContainer}
      style={{
        boxShadow: selected
          ? "0 6px 20px rgba(0, 188, 212, 0.6)"
          : "0 4px 12px rgba(0, 188, 212, 0.4)",
      }}
    >
      <NodePorts color="#00BCD4" />
      <Box className={classes.nodeHeader}>
        <Code className={classes.nodeIcon} />
        <Typography className={classes.nodeLabel}>Agente IA</Typography>
      </Box>
      <Box className={classes.nodeContent}>
        {promptId ? (
          agentName.length > 50 ? `${agentName.substring(0, 50)}...` : agentName
        ) : (
          "Sin agente seleccionado"
        )}
      </Box>
      {promptId && (
        <Typography className={classes.nodeMeta}>
          ID: {promptId}
        </Typography>
      )}
    </Box>
  );
};

export default OpenAINode;
